let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

var id = getUrlParameter('id'), f_name = "", C_number = "", C_email = "", user__gender = "", user_gender = "", rid = "", caseId = "", selectedStage = 'Stage-1';
var cohort = getUrlParameter('cohort'), variantsID = 0, recommended_products = [], variantsIDs = [];
var prices = 0, doc__fee = 100000, diet__plan = 50000, hair__coach_fee = 50000, month1_total, month1DiscountPrice, month3DiscountPrice, month6DiscountPrice, discount_pricetext = 0;
let successfulFetchCount = 0, totalProducts = 0;
if (id) {
  localStorage.setItem('user-gender', 'male');
  localStorage.setItem('rid', id);
}
id = localStorage.getItem('rid');
if(id === undefined) {
  id = getCookie('syntheticId');
}
(function () {
  if(!id) {
    if(window.location.pathname == '/pages/result-hi'){
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      document.location.href= 'https://form.traya.health/questions?cohort=1&source=ResultPage'
    }
    var data_formPage = document.querySelectorAll('[data-formPage]'),
      data_resultPage = document.querySelectorAll('[data-resultPage]'),
      data_resultbtn = document.querySelectorAll('[data-resultbtn]'),
      data_notResult = document.querySelectorAll('[data-notResult]');
    if(data_formPage.length != 0) {
      data_formPage.forEach((formpage) => { formpage.style.display = "block"; });
    }
    if(data_resultPage.length != 0) {
      data_resultPage.forEach((resultpage) => { resultpage.style.display = "none"; });
    }
    if(data_resultbtn.length != 0) {
      data_resultbtn.forEach((resultbtn) => { resultbtn.style.display = "none"; });
    }
    if(data_notResult.length != 0) {
      data_notResult.forEach((notresult) => { notresult.style.display = "block"; });
    }
  }else {
    setotherCookie('syntheticId', id, 30, '.traya.health');
    var data_result = document.querySelectorAll('[data-result]');
    if(data_result.length != 0) {
      data_result.forEach((result) => { result.style.display = "block"; })
    }
  }
  var baseUrls = {
    DEV: 'https://api.dev.hav-g.in/',
    PROD: 'https://api.hav-g.in/'
  };
  var tokens = {
    DEV: { 
      "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
    },
    PROD: { 
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    }
  };
  var token = tokens.PROD;
  var baseUrl = baseUrls.PROD;
  var liveendpoint = 'https://api.hav-g.in/dgReport?id=';
  if (cohort == 2) {
    liveendpoint = baseUrl + 'dgReport/v2?id=';
  } else {
    liveendpoint = baseUrl + 'dgReport/v1?id=';
  }
  liveendpoint = 'https://api.hav-g.in/dgReport/hinglish?id=';
  window.addEventListener('DOMContentLoaded', function() {
    var hindi_button = document.querySelectorAll(".header__icons_language_hi"), english_button = document.querySelectorAll(".header__icons_language_en");
    var query = window.location.search;
    if(hindi_button.length != 0) {
      hindi_button.forEach((btn) => {
        btn.setAttribute("href", `/pages/result-hi${query}`);
      })
    }
    if(english_button.length != 0) {
      english_button.forEach((btn) => {
        btn.setAttribute("href", `/pages/result4${query}`);
      })
    }
    clearCart();
    var atcButton = document.querySelectorAll('#add-to-cart-result-page');
    if(atcButton.length != 0) {
      atcButton.forEach((button) => {
        button.addEventListener('click', function() {
          fetch('/cart/clear.js', {
            method: "POST",
            headers: {
              'Content-Type': 'application/json'
            }
          }).then((response) => {
            return response.json();
          }).catch((error) => {
            console.error('Error: ', error);
          }).finally(() => {
            checkout();
          })
        })
      });
    }
    getMaleResult(liveendpoint, id, token);
  })
})();


var clearCart = function() {
  var formdata = {
    sections: 'cart-drawer'
  };
  fetch('/cart/clear.js', {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formdata)
  }).then((response) => {
    return response.json();
  }).then((result) => {
    var t = document.querySelector('cart-drawer');
    let cart_drawer = result.sections['cart-drawer'];
    CartDrawerUpdate(t, cart_drawer, drawer=false,0);
  }).catch((error) => {
    console.error('Error: ', error);
  })
}

function getMaleResult(livepoint, id, token) {
  document.body.style.overflow = 'hidden';
  fetch(`${livepoint}${id}`, {
    headers: token
  }).then((response) => {
    return response.json();
  }).then((response) => {
    ShowContent(response);
    rootCause(response?.root_causes);
    resultMonthKit(response);
    displayProduct(response);
    sectionBlocksDisplay(response);
    customPriceSection(response);
    sectionMonthsExpectetion(response);
    sectionRealStories(response);
    sectionCoach(response);
  }).then(()=> {
  addClickEventListernerToMonthkit();
}).catch((error) => {
    console.error('Error: ', error);
     document.body.style.overflow = 'unset';
  });
}

// Checking Eligibility
function checkEligibility() {
  // Hide the checking container and show the loading container
  document.querySelector('.checking-container').style.display = 'none';
  document.querySelector('.loading-container').style.display = 'flex';
  
  // Simulate an API call with setTimeout
  setTimeout(() => {
    // Hide the loading container and show the eligibility result container
    document.querySelector('.loading-container').style.display = 'none';
    document.querySelector('.eligibilty-result').style.display = 'block';
  }, 1000); // Change the duration as needed
}
        
// doctor assigned section
function sectionCoach(response) {
  let stagesDoctorAssigned = response.currentStage;
  let assignedDoctor = document.querySelector('.doctor-assigned');
  let assignedDoctorPending = document.querySelector('.doctor-assigned--pending');
  const responseStage = stagesDoctorAssigned.stage; 
  

  // Check the value of responseStage and display the appropriate div
  if (responseStage === 'Stage-1') {
    assignedDoctor.style.display = 'block'; // or 'flex', depending on your layout
    assignedDoctorPending.style.display = 'none';
  } else {
    assignedDoctor.style.display = 'none';
    assignedDoctorPending.style.display = 'block'; // or 'flex', depending on your layout
  }
}

// Function to create and show the popup
function showProductPopup(productId,language) {
  let popup = document.querySelector('.product-popup');
  let prodId = document.querySelector('[data-product-id]').getAttribute('data-product-id');
  console.log(prodId)

  // Create the popup if it doesn't exist
  if (!popup) {
    popup = document.createElement('div');
    popup.classList.add('product-popup');
    
    popup.innerHTML = `
      <div class="popup-content">
        <span class="close-btn">&times;</span>
        <iframe class="popup-iframe" src="" frameborder="0"></iframe>
      </div>
    `;
    document.body.appendChild(popup);

    // Add event listener to the close button
    popup.querySelector('.close-btn').addEventListener('click', () => {
      popup.classList.remove('show');
      document.body.style.overflow = '';
      document.querySelector('.empty-div').style.display = "none";
    });
  }
 
  // Set the iframe source and show the popup
  const iframe = popup.querySelector('.popup-iframe');
  iframe.src = `https://form.traya.health/product-drawerv2/${productId}`;
  popup.classList.add('show');
  document.body.style.overflow = 'hidden';
  document.querySelector('.empty-div').style.display = "flex";
}


// Function to create the product with a drawer
function createProductWithDrawer(data) {
  const productName = data.productPageData.content.product_name;
  showProductPopup(productName);
}

// Function to fetch product data and show it in the popup
function showMonthKitProductData(productId, language) {
  const tokens = {
    DEV: {
      "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
    },
    PROD: {
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    }
  };

  fetch(`https://public-jgfas325.hav-g.in/productContentv2/${productId}?language=${language}`, {
    headers: tokens.PROD // Assuming tokens.PROD contains necessary headers
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  }).then((data) => {
    createProductWithDrawer(data);
  }).catch((error) => {
    console.error('Error fetching data:', error);
  });
}

// Function to add click event listener to month kit product cards
function addClickEventListernerToMonthkit() {
  document.querySelectorAll('.shopify-kit-section .kit-card').forEach((kit) => {
    kit.addEventListener('click', function (event) {
      const productId = event.currentTarget.getAttribute('data-product-id');
      const language = 'english'; // Assuming 'english' is the desired language
      showProductPopup(productId, language);
    });
  });
}

// Function to create the month kit section
function resultMonthKit(response) {
    const productData = response.product_Ids;
    const priceCart = response.cart_price
    
  
    // Create the container div
    const containerDiv = document.createElement('div');
    containerDiv.classList.add('kit-container', 'container');
  
    // Create the header and add it to the container
    const header = document.createElement('h2');
    header.classList.add('kit-header', 'section-heading-font');
    header.innerText = 'Aapka 1st month kit';
    containerDiv.appendChild(header);
  
    if(window.innerWidth <= 767){
      containerDiv.classList.remove('container');
    }
    // Create the section and add it to the container
    const newSection = document.createElement('section');
    newSection.classList.add('shopify-kit-section');
  
    // Add the product data to the section
    productData.forEach((each) => {
      const productDiv = document.createElement('div');
      productDiv.classList.add('kit-card');
      productDiv.dataset.productId = each.product_id;
      productDiv.innerHTML = `
        <div class="product-imge">
          <img src="${each.image_url.singleImage}" /> 
        </div>
        <div class="product-description">
          <div class="prod-heading">
            <p class="prod-title">${each.name}</p>
            <div class="tags">
              <img src="${each.tag.icon}" />
              <p class="tag-title">${each.tag.title}</p>
            </div>
          </div>
          <div>
            <p class="prod-details">${each.oneLiner}</p>
          </div>
          <div>
            <p class="prod-price">${each.price}</p>
          </div>
        </div>
        <div class="arrow">    
          <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.53255 7.03063L1.53255 12.0306C1.39165 12.1715 1.20056 12.2507 1.0013 12.2507C0.802043 12.2507 0.610947 12.1715 0.470051 12.0306C0.329155 11.8897 0.25 11.6986 0.25 11.4994C0.25 11.3001 0.329155 11.109 0.470051 10.9681L4.93943 6.5L0.471301 2.03063C0.401536 1.96086 0.346196 1.87804 0.308439 1.78689C0.270683 1.69574 0.25125 1.59804 0.25125 1.49938C0.25125 1.40072 0.270683 1.30302 0.308439 1.21187C0.346196 1.12072 0.401536 1.03789 0.471301 0.968128C0.541066 0.898364 0.623889 0.843023 0.715041 0.805267C0.806193 0.76751 0.903889 0.748077 1.00255 0.748077C1.10121 0.748077 1.19891 0.76751 1.29006 0.805267C1.38121 0.843023 1.46404 0.898364 1.5338 0.968128L6.5338 5.96813C6.60364 6.03789 6.65902 6.12075 6.69677 6.21196C6.73451 6.30316 6.75388 6.40093 6.75377 6.49964C6.75365 6.59835 6.73405 6.69606 6.69609 6.78718C6.65813 6.8783 6.60255 6.96103 6.53255 7.03063Z" fill="black" />
          </svg>
        </div>
      `;
      newSection.appendChild(productDiv);
    });
    
    // Append the section to the container
    containerDiv.appendChild(newSection);
  
    // Insert the container into the DOM
    const firstSection = document.querySelectorAll('main .ss.test-result')[0];
    if (firstSection && firstSection.parentNode) {
      firstSection.parentNode.insertBefore(containerDiv, firstSection.nextSibling);
    }
  
    // Add click event listeners to the product cards
    addClickEventListernerToMonthkit();
}

// functionality for real stories
function sectionRealStories(response) {
  let { successStories } = response;
  if (successStories.showComponent == true) {
    const imgCarousel = document.querySelector('.image-carousel');
    const titleElement = document.querySelector('.stories-main-heading');
    const subTitleElement = document.querySelector('.stories-sub-heading');

    // Set title and subtitle
    titleElement.textContent = `Logon ki Asli Kahaniyan`;
    subTitleElement.textContent = `Customers jinhone aapke hair profile se match kiya`;

    // Loop through each story to create image elements
    successStories.stories.forEach((storyUrl) => {
      const imgCarouselBlock = document.createElement('div');
      imgCarouselBlock.className = 'image-carousel-container';
      imgCarouselBlock.innerHTML = `
        <div class="image-carousel--container-img position-relative mx-2">
          <img src="${storyUrl.imageUrl}" alt="Success Story" height="auto" width="auto">
        </div>
      `;
      imgCarousel.appendChild(imgCarouselBlock);
    });

    // Initialize the Slick carousel after appending elements
    $(imgCarousel).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true, 
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "15px",
            dots: true,
          },
        },
      ],
    });
  }
}

// doctor recomandation section 
function sectionBlocksDisplay(response) {
  let { stage_transition } = response;
  let stage = stage_transition.currentStage.stage;
  const apiSection = document.querySelector('.static-block-container');
  const staticSection = document.querySelector('.block-container');

  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  if (stage === 'Stage-1') {
    apiSection.style.display = 'none';
    staticSection.style.display = isDesktop ? 'flex' : 'block';
  } else {
    apiSection.style.display = isDesktop ? 'flex' : 'block';
    staticSection.style.display = 'none';
  }
}
// doctor recomandation section end

// custom price 
function customPriceSection(response) {
  let cartPrice = response.cart_price;
  cartPrice = parseFloat(cartPrice).toFixed(2);
    if (cartPrice.endsWith('.00')) {
      cartPrice = parseInt(cartPrice);
    }

  const dynamicPriceElements = document.querySelectorAll('#dynamic-price');
  if (dynamicPriceElements.length > 0) {
    dynamicPriceElements.forEach(element => {
      element.innerHTML = cartPrice;
    });
  } else {
    console.error('Price elements not found');
  }
}
// end of custom price

// timeline section 
function sectionMonthsExpectetion(response) {
  let { monthsExpectation } = response;
  if (monthsExpectation.showComponent == true) {
    const timeline = document.getElementById('timeline');
    const weeksUpdateElement = document.querySelector('.weeks-update')
    weeksUpdateElement.innerHTML = monthsExpectation.months;
    monthsExpectation.monthExpectations.forEach((month, index) => {
        const block = document.createElement('div');
        block.className = 'timeline-block';
        block.innerHTML = `
            <div class="timeline-icon">
              <img src="${month.image_url}" alt="Month ${month.month}">
            </div>
            ${index < monthsExpectation.monthExpectations.length - 0 ? `
              <div class="timeline-dot-line">
                <div class="timeline-dot"></div>
                <div class="timeline-line"></div>
              </div>
            ` : ''}
            <div class="timeline-content">
              <p><strong>Month ${month.month}</strong></p>
              <p>${month.goal}</p>
            </div>
        `;
       timeline.appendChild(block);
    });
    if(window.innerWidth > 767){
      $(timeline).slick({
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              centerMode: true,
              centerPadding: "15px",
            },
          },
        ],
      });
    }
  }
}

function moneyBackPolicy(){
  const handle = 'money-back-policy';
  fetch(`/pages/${handle}.js`)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Assuming the response is JSON
  })
  .then(data => {
    console.log(data);
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
}

function rootCause (response) {
  const primaryRootCause = response?.primaryRootCause ?? [];
  const defaultRootCause = response?.defaultRootCause ?? [];
  let primaryRootCauseHtml = '';
  let primaryRootCauseContentHtml = '';
  if (primaryRootCause.length > 0) {
    primaryRootCauseHtml = `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border active text-center" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tab" aria-controls="${primaryRootCause[0]?.title.replace(/ /g, "-")}" aria-selected="true">
        <div class="rootCauseLinkImg">
          <img src="${primaryRootCause[0]?.details?.icon}" />
        </div>
         <p class="mt-2">${primaryRootCause[0]?.title}</p>
      </a>
    </li>`;
  }
  if (primaryRootCause.length > 0) {
    primaryRootCauseContentHtml = `<div class="tab-pane fade show active" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${primaryRootCause[0]?.details?.description?.english}</p>
    </div>`;
  }
  const defaultRootCauseHtml = defaultRootCause.map((item) => {
    return `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border text-center" id="${item?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${item?.title.replace(/ /g, "-")}" role="tab" aria-controls="${item?.title.replace(/ /g, "-")}" aria-selected="false">
        <div class="rootCauseLinkImg">
          <img src="${item?.details?.icon}" />
        </div>
        <p class="mt-2">${item?.title}</p>
      </a>
    </li>`;
  }).join('');
  const defaultRootCauseContentHtml = defaultRootCause.map((item) => {
    return `<div class="tab-pane fade" id="${item?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${item?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${item?.details?.description?.english}</p></div>`;
  }).join('');
  const rootCauseHtml = `<ul class="nav rootCause-nav-tabs border-0" id="myTab" role="tablist">${primaryRootCauseHtml}${defaultRootCauseHtml}</ul>
  <div class="tab-content rootCauseTabContent p-2 p-md-3 mt-3" id="myTabContent">${primaryRootCauseContentHtml}${defaultRootCauseContentHtml}</div>`;
  const rootCauseSectionWrapper = document.getElementById('rootCouseSectionWrapper');
  if (rootCauseSectionWrapper) {
    rootCauseSectionWrapper.innerHTML = rootCauseHtml;
  }
}

function displayProduct(response) {
  var r = Object.assign(response.User_Analysis, response.Recommendations);
  f_name = r.first_name;
  C_number = r.phone;
  C_email = r.email;
  user__gender = r.gender;
  setCookie('user_phone', C_number, 30);
  caseId= r.case_id;
  localStorage.setItem('caseId', caseId);
  tagClarityCaseId(caseId);
  if(user__gender == 'M') {
    user_gender = 'Male';
  }
  var coin_size = false;
  if(r.stage == 'Coin Size Patch') {
    coin_size = true;
  }
  var productTemplate = 'result-product-list', slides = 1, mobileSlides = 1 ,arrows = false, dots = true;
  if(r.stage == "Stage-1") {
    productTemplate = 'result4c-card', slides = 3, mobileSlides = 1.3;
  }else {
    productTemplate = 'result4c-card', slides = 3, mobileSlides = 1.3;
    // productTemplate = 'result-product-list', slides = 1, mobileSlides = 1;
  }
  var test_result = document.querySelectorAll('.test-result'), product_section_list = document.querySelectorAll('.product-section-list'),
  product_section = document.querySelectorAll('.product-section'), cust_reviews = document.querySelectorAll('.cust_reviews'),
  our_experts = document.querySelectorAll('.our-experts'), sticky_btn = document.querySelectorAll('.sticky-btn'), 
  transplant_stage_six = document.querySelectorAll('.transplant-stage-six'), normal_page_is = true, data__gender = document.querySelectorAll('[data-gender]');
  var genderStage1Main = document.querySelector('.gender-m-stage-1'), otherStages1Main = document.querySelector('.other-m-stage-1'),
  stage_pro__title = document.querySelectorAll('.stage1_pro_title_hide'), stage1_pro__title = document.querySelectorAll('.m-stage-1-Pro_title'),
  root_impacting_stage1 = document.querySelectorAll('.root_impacting_stage1'), product__section__list = document.querySelectorAll('.product-section-list'),
  stage1_hairgrowth = document.querySelector('.stage1_hairgrowth'), satge1_doctor = document.querySelector('.satge1_doctor'),
  stage1_coach = document.querySelector('.stage1_coach'), stageDescription_text = document.querySelectorAll('.stageDescription_text'),
  result4_cust_reviews = document.querySelectorAll('.result4.cust_reviews'), stage_1_testimonial = document.querySelectorAll('.stage_1_testimonial'),
  issue_hair_goal = document.querySelectorAll('.issue_hair_goal'), stage1_Text = document.querySelectorAll('.stage1_Text'),
  user_type_stage = document.querySelectorAll('.user_type_stage'), diagnosed_text = document.querySelectorAll('.diagnosed_text'),
  stage_1__title = document.querySelectorAll('.m-stage-1-title'), root_cause__text = document.querySelectorAll('.root-cause-text'),
  rootCauseImage = document.querySelectorAll('.root-cause-text.root-cause-text-desk.new_root img'), root_only_img = document.querySelectorAll('.root_only_img'),
  product_section__cards = document.querySelectorAll('.product-section-list>.container>.card'),
  productKitSection = document.querySelectorAll('.kit-container'), doctorsSection = document.querySelectorAll('.section-coach.container'),
  timelineSection = document.querySelectorAll('.timeline--container'), priceBreakStage = document.querySelectorAll('.custom-price-section'),
  eligibilityCheck = document.querySelectorAll('.eligibility-check--section'), faqSection = document.querySelectorAll('.aldrich-faq');
  if(r.gender == 'M' && r.stage == "Stage-6"){
    document.querySelector('body.result4').style.width = '100%';
    document.querySelector('body.result4 #MainContent').style.padding = 0;
    normal_page_is = false;
  }else{
    normal_page_is = true;
  }
  if(test_result.length != 0) {
    test_result.forEach((result) => {
      if(normal_page_is == false) {
        result.classList.add('d-none');
      }else {
        result.classList.remove('d-none');
      }
    })
  }
  if(productKitSection.length != 0) {
    productKitSection.forEach((kit) => {
      if(normal_page_is == false) {
        kit.classList.add('d-none');
      }else {
        kit.classList.remove('d-none');
      }
    })
  }
  if(doctorsSection.length != 0) {
    doctorsSection.forEach((doctors) => {
      if(normal_page_is == false) {
        doctors.classList.add('d-none');
      }else {
        doctors.classList.remove('d-none');
      }
    })
  }
  if(timelineSection.length != 0) {
    timelineSection.forEach((time) => {
      if(normal_page_is == false) {
        time.classList.add('d-none');
      }else {
        time.classList.remove('d-none');
      }
    })
  }
  if(priceBreakStage.length != 0) {
    priceBreakStage.forEach((priceBreak) => {
      if(normal_page_is == false) {
        priceBreak.classList.add('d-none');
      }else {
        priceBreak.classList.remove('d-none');
      }
    })
  }
  if(eligibilityCheck.length != 0) {
    eligibilityCheck.forEach((check) => {
      if(normal_page_is == false) {
        check.classList.add('d-none');
      }else {
        check.classList.remove('d-none');
      }
    })
  }
  if(faqSection.length != 0) {
    faqSection.forEach((faq) => {
      if(normal_page_is == false) {
        faq.classList.add('d-none');
      }else {
        faq.classList.remove('d-none');
      }
    })
  }
  if(product_section_list.length != 0) {
    product_section_list.forEach((list) => {
      if(normal_page_is == false) {
        list.classList.add('d-none');
      }else {
        list.classList.remove('d-none');
      }
    });
  }
  if(product_section.length != 0) {
    product_section.forEach((section) => {
      if(normal_page_is == false) {
        section.classList.add('d-none');
      }else {
        section.classList.remove('d-none');
      }
    });
  }
  if(cust_reviews.length != 0) {
    cust_reviews.forEach((section) => {
      if(normal_page_is == false) {
        section.classList.add('d-none');
      }else {
        section.classList.remove('d-none');
      }
    });
  }
  if(our_experts.length != 0) {
    our_experts.forEach((section) => {
      if(normal_page_is == false) {
        section.classList.add('d-none');
      }else {
        section.classList.remove('d-none');
      }
    });
  }
  if(sticky_btn.length != 0) {
    sticky_btn.forEach((section) => {
      if(normal_page_is == false) {
        section.classList.add('d-none');
      }else {
        section.classList.remove('d-none');
      }
    });
  }
  if(transplant_stage_six.length != 0) {
    transplant_stage_six.forEach((section) => {
      if(normal_page_is == false) {
        section.classList.remove('d-none');
      }else {
        section.remove();
      }
    });
  }
  // Product Recommendation
  if(r.Health_tatva === 'Yes') {
    recommended_products.push({
      'handle': 'herbal-tablets',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if(r.Gut_shuddi === 'Yes') {
    recommended_products.push({
      'handle': 'avipattikar-digestion-tablets',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if(r.Minoxidil === 'Yes' && r.gender === 'M') {
    recommended_products.push({
      'handle': 'traya-minoxidil-5',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if(r.Minoxidil === 'Yes' && r.gender === 'F') {
    recommended_products.push({
      'handle': 'minoxidil-2',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if(r.Shampoo === 'Normal') {
    recommended_products.push({
      'handle': 'shampoo',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if(r.Shampoo === 'Anti dandruff') {
    recommended_products.push({
      'handle': 'anti-dandruff-shampoo',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if(r.Hair_vitamin === 'Yes') {
    recommended_products.push({
      'handle': 'hair-vitamin-with-dht-blockers-biotin-and-bhringraj',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if((r.Serum === 'Yes') && (r.RCP === 'No')) {
    recommended_products.push({
      'handle': 'recap-serum-for-hair-fall-control',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if(r.RCP === 'Yes') {
    recommended_products.push({
      'handle': 'recap-serum-for-hair-fall-control',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if(r.Hair_ras === 'Yes') {
    recommended_products.push({
      'handle': 'hair-growth-herbs',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  var boosterOil = "", handle = "";
  if (r.Calm_Therapy_Booster_Oil === 'Yes'){
    handle = "scalp-oil-with-calm-oil-shot-50ml";
    boosterOil = " + Calm Therapy Booster Oil";
  }else if(r.Dandruff_Therapy_Booster_Oil === 'Yes') {
    handle = "scalp-oil-with-dandruff-oil-shot-50ml";
    boosterOil = " + Dandruff Therapy Booster Oil";
  }else if(r.Growth_Therapy_Booster_Oil === 'Yes') {
    handle = "scalp-oil-with-growth-oil-shot-50ml";
    boosterOil = " + Growth Therapy Booster Oil";
  }else if(r.Scalp_Therapy_Booster_Oil === 'Yes') {
    handle = "scalp-oil-with-scalp-health-oil-shot-50ml";
    boosterOil = " + Scalp Therapy Booster Oil";
  }
  if(handle){
    recommended_products.push({
      'handle': handle,
      'co_handle': boosterOil,
      'coin_size': coin_size
    });
  }
  if(r.Kevon === 'Yes') {
    recommended_products.push({
      'handle': 'ketoconazole-2-night-lotion',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if(r.Nasya === 'Yes') {
    recommended_products.push({
      'handle': 'shatavari-ghrita',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if(r.Digest_Boost === 'Yes') {
    recommended_products.push({
      'handle': 'digest-boost-for-improved-digestive-ability-traya-health',
      'co_handle': '',
      'coin_size': coin_size
    });
  }
  if(r.gender === 'M'){
    if(data__gender.length != 0) {
      data__gender.forEach((gender) => { gender.append('Male'); });
    }
  } else {
    document.location.href= `/pages/female-result?id=${id}`;
    if(data__gender.length != 0) {
      data__gender.forEach((gender) => { gender.append('Female'); });
    }
  }
  if(recommended_products.length != 0) {
    var product_counts = document.querySelectorAll('[product_count]');
    if(product_counts.length != 0) {
      product_counts.forEach((count) => {
        count.innerHTML = `- (${recommended_products.length} Products)`
      })
    }
    const fetchPromises = [];
    totalProducts = recommended_products.length;
    recommended_products.forEach((product) => {
      const fetchPromise = getProductByHandle(product.handle, product.co_handle, product.coin_size, productTemplate, successfulFetchCount);
      fetchPromises.push(fetchPromise);
    });
    Promise.all(fetchPromises).then(() => {
      if (successfulFetchCount === totalProducts) {
        setTimeout(() => {
          InitProductSlider(slides, mobileSlides);
        }, 1000)
      }
    }).catch((error) => {
      console.error('One or more fetch requests failed: ', error);
    });
  }
  // Recommended Products End
  if (r.stage == "Stage-1") {
    document.querySelector('#stage').innerHTML = 'Stage 1 Of ';
  }else if (r.stage == "Stage-2") {
    document.querySelector('#stage').innerHTML = 'Stage 2 Of ';
  }else if(r.stage == "Stage-3"){
    document.querySelector('#stage').innerHTML = 'Stage 3 Of ';
  }else if(r.stage == "Stage-4"){
    document.querySelector('#stage').innerHTML = 'Stage 4 Of ';
  }else if(r.stage == "Stage-5"){
    document.querySelector('#stage').innerHTML = 'Stage 5 Of ';
  }
  if (trayaProcessingAnimation) {
    trayaProcessingAnimation.style.display = 'none';
  }
  document.body.style.overflow = 'unset';
}

function InitProductSlider(slides, mobileSlides) {
  $('.result_product_slides').slick({
    slidesToShow: slides,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: mobileSlides,
          slidesToScroll: 1,
          infinite: false,
          arrows: false
        }
      }
    ]
  });
}

function getProductByHandle(handle, co_handle, coin_size, productTemplate) {
  return new Promise((resolve, reject) => {
    try {
      fetch(`/products/${handle}.js`, {
        method: 'GET'
      }).then((response) => {
        return response.json();
      }).then((product) => {
        var { price, variants } = product, final_price = 0;
        prices = prices + price;
        final_price = (prices/100);
        discount_price = (final_price+2000);
        discount_pricetext = (discount_price-final_price);
        var discount_per = parseInt((discount_pricetext / discount_price)*100);
        var off_percent = document.querySelector('.per__off'), all_total_price = document.querySelectorAll('.all-total-price'),
        total_price = document.querySelectorAll('.total-price'), model_discount_price = document.querySelectorAll('.model_discount_price'),
        aTCButton4 = document.querySelectorAll('#add-to-cart-result-page'), stickyAtcButton4 =  document.querySelectorAll('.sticky-btn #add-to-cart-result-page');
        if(off_percent) {
          off_percent.innerHTML = `(${discount_per} % OFF)`;
        }
        if(all_total_price.length != 0) {
          all_total_price.forEach((div_total_price) => { div_total_price.innerHTML = `₹ ${discount_price}`; })
        }
        if(total_price.length != 0) {
          total_price.forEach((t_price) => { t_price.innerHTML = `₹ ${final_price}`; })
        }
        if(model_discount_price) {
          model_discount_price.forEach((discount_price) => { discount_price.innerHTML = `You Saved ₹ ${discount_pricetext}`; })
        }
        if(aTCButton4.length != 0) {
          aTCButton4.forEach((btn4) => { btn4.setAttribute('data-price', final_price); });
        }
        if(stickyAtcButton4.length != 0) {
          stickyAtcButton4.forEach((btn4) => { btn4.setAttribute('data-price', final_price); });
        }
        variantsIDs.push({
          'id': variants[0].id,
          'quantity': 1
        })
        resolve();
        successfulFetchCount++;
      }).catch((error) => {
        console.error('Product Error: ', error);
        reject(error);
      });
      fetch(`/products/${handle}?view=${productTemplate}`).then((response) => {
        return response.text();
      }).then((response) => {
        var html = new DOMParser().parseFromString(response, 'text/html')?.querySelector('.col-md-12');
        var result4c = new DOMParser().parseFromString(response, 'text/html')?.querySelector('.col-12.col-md-4');
        var result_div = document.querySelector('.product-section .container > .row');
        if(result_div && html) {
          result_div.append(html);
          if(coin_size == true) {
            var coin_sizes = document.querySelectorAll('.product-section .container > .row .toChange');
            if(coin_sizes.length != 0) {
              coin_sizes.forEach((coin) => {
                coin.innerHTML = 'Hair Health';
              })
            }
          }
        }
        if(result_div && result4c) {
          result_div.append(result4c);
          if(coin_size == true) {
            var coin_sizes = document.querySelectorAll('.product-section .container > .row .toChange');
            if(coin_sizes.length != 0) {
              coin_sizes.forEach((coin) => {
                coin.innerHTML = 'Hair Health';
              })
            }
          }
        }
      }).catch((error) => {
        console.error('Error: ', error);
        reject(error);
      });
    } catch (error) {
      console.error('Error: ', error);
      reject(error);
    }
  });
}

function checkout() {
  localStorage.setItem('user__gender',user_gender);
  localStorage.setItem('caseId',caseId);
  variantsIDs.forEach((e) => {
    if(e.id === 37681124081842){
      e.properties = {'Plan': 'Dandruff'};
    }else if(e.id === 42648509186226){
      e.properties = {'Plan': 'Dandruff'};
    }else if(e.id === 41899898011826){
      e.properties = {'Plan': 'Dandruff'};
    }else {
      e.properties = {'Plan': 'Auto'};
    }
  });
  let formData = {
    'items': variantsIDs,
    sections: 'cart-drawer',
    attributes: {
      first_name: f_name,
      phone: C_number,
      email: C_email,
      caseid: caseId
    }
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {  
    localStorage.setItem('User_location', "cart");
    return response.json();
  }).then(result => { 
    var t = document.querySelector('cart-drawer');
    let cart_drawer = result.sections['cart-drawer'];
    CartDrawerUpdate(t, cart_drawer);
  }).catch((error) => {
    console.error('Error:', error);
  }).finally(() => {
    cartData();
  });
}

function ShowContent(response) {
  var data = Object.assign(response.User_Analysis, response.Recommendations);
  let stageDescription = response.stageWiseDescription.english;
  var growthPossibility = response.growthPossibilityBar;
  var maxMonth = response.Recommendations.Max_months;
  var grothBar = document.querySelector(".cstm-growthPossibilityBar")
  var treatedCount = response.treatedCXCount.description;
  var treatedCountDOM = document.querySelector(".customer-based-profile");
  var treatmentDuration = document.querySelector(".traetment-duration");
  if(treatmentDuration){
    treatmentDuration.innerText = `${maxMonth} Mahine`;
  }
  if(treatedCountDOM){
    treatedCountDOM.innerText = treatedCount;
  }
  var illness = data.experienced_in_one_year, genetics = data.Genetic, userStage = data.stage;
  var userName = document.querySelectorAll('[data-user-name]'), name1 = document.querySelectorAll('#name1'),
  name3 = document.querySelectorAll('#name3'), stage1 = document.querySelectorAll('#stage1'),
  typeOfLoss3 = document.querySelectorAll('#typeOfLoss3'), stage3 = document.querySelectorAll('#stage3'),
  stageDescriptionMain = document.querySelectorAll('#stageDescription'), stage3 = document.querySelectorAll('#stage3'),
  typeOfLoss = document.querySelectorAll('#typeOfLoss'), mainstage = document.querySelectorAll('#stage');
  var ourdia = document.querySelector('#ourdia'), stagesnames = document.querySelectorAll('.stages-name');
  var stageImage = response?.currentStage?.imgUrl;
  if(growthPossibility && grothBar && growthPossibility == true){grothBar.style.display = "block";}
  if(userName.length != 0) { userName.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(name1.length != 0) { name1.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(name3.length != 0) { name3.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(stage1.length != 0) { stage1.forEach((stage) => { stage.innerHTML = `${data.stage.replace(/-/g, ' ')}` }) }
  if(typeOfLoss3.length != 0) { typeOfLoss3.forEach((loss) => { loss.innerHTML = `${data.Type_of_hair_loss}` }) }
  if(stage3.length != 0) { stage3.forEach((stage) => { stage.innerHTML = `${data.stage.replace(/-/g, ' ')}` }) }
  if(stageDescriptionMain.length != 0) { 
    stageDescriptionMain.forEach((stage) => { 
      if(response.User_Analysis.stage == "Heavy Hair Fall"){
        stage.innerHTML = `Telogen effluvium ya heavy hair fall tab hota hai jab aapke body ko kisi major shock ka samna karna padta hai. Ye type ka hair loss completely reversible hota hai, aur humein poora vishwas hai ki aapko 3-6 mahine ke andar results dikhna shuru ho jayenge.`;
      } else {
        stage.innerHTML = `${stageDescription}`; 
      }
    })
  }
  if(illness.length != 0) {
    var TECondition = illness.filter((ill) => {
      if(ill == 'Severe Illness (Dengue, Malaria, Typhoid or Covid)') {
        return ill;
      }
    })
    if(TECondition.length == 1 && (genetics == 'Yes' || genetics == 'No') && (userStage == 'Heavy Hair Fall Across The Head' || userStage == 'Heavy Hair Fall')) {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `Telogen Effluvium`; }) }
      // if(mainstage.length != 0) { mainstage.forEach((stage) => { stage.innerHTML = `${data.stage.replace(/-/g, ' ')}` }) }
    }else if(TECondition.length == 0 && genetics == 'Yes' && (userStage == 'Heavy Hair Fall Across The Head' || userStage == 'Heavy Hair Fall')) {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `of Male Pattern Hair Loss par hain`; }) }
    }else if(TECondition.length == 0 && genetics == 'No' && (userStage == 'Heavy Hair Fall Across The Head' || userStage == 'Heavy Hair Fall')) {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `Telogen Effluvium`; }) }
      if(mainstage.length != 0) { mainstage.forEach((stage) => { stage.innerHTML = `${data.stage.replace(/-/g, ' ')}` }) }
    }else {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `${data.Type_of_hair_loss}`; }) }
    }
  }
  if(stagesnames.length) {showOrHide(stagesnames, "none");}
  /* Coin Size Changes */
  if(userStage == 'Coin Size Patch') {
    var coin_main_title = document.querySelectorAll('#coin-main-title'), coin_plan_title = document.querySelectorAll('#coin-plan-title'),
    cust_reviews = document.querySelectorAll('.cust_reviews');
    if(coin_main_title.length != 0) { coin_main_title.forEach((title) => { title.innerHTML = `'s Treatment Plan`; }) }
    if(coin_plan_title.length != 0) { coin_plan_title.forEach((title) => { title.innerHTML = `Your Hair Treatment plan`; }) } 
    if(cust_reviews.length != 0) { cust_reviews.forEach((review) => { review.style.display = "none"; }) }
  }
  /* Coin Size Changes */

  // Display the element based on user stage
  function displayStageElement(stageClass) {
      const element = document.querySelector(stageClass);
      if (element) {
          element.style.display = 'block';
      } else {
          console.error(`Element with class ${stageClass} not found.`);
      }
  }
  
  // Check user stage and display the corresponding result
  switch (userStage) {
    case 'Stage-2':
        displayStageElement('.cstm-stage__2');
        break;
    case 'Stage-3':
        displayStageElement('.cstm-stage__3');
        break;
    case 'Stage-4':
        displayStageElement('.cstm-stage__4');
        break;
    case 'Stage-5':
        displayStageElement('.cstm-stage__5');
        break;
    case 'Heavy Hair Fall Across The Head':
    case 'Heavy Hair Fall':
        displayStageElement('.cstm-stage__TE');
        break;
    default:
        console.warn('No matching stage found for userStage:', userStage);
        break;
  }
  
  /* Stage1 You Should + Card Section Changes */
  var userAge = response.User_Analysis.age;

  if(userStage === 'Stage-1') {    
    document.querySelector('.why-you-should').style.display = 'block';
    document.querySelector('.stage_1_testimonial').style.display = 'none';
    document.querySelector('.stage1-new-testimonial').style.display = 'block';
    document.querySelector('.user-age-1').textContent = userAge;
    document.querySelector('.user-age-2').textContent = userAge + 5;
    document.querySelector('.user-age-3').textContent = userAge + 10;
  }
  /* Stage1 You Should + Card Section Changes */

  /* Dandruff Response */
  var dandruffResp = response.User_Analysis.dandruff_response;
  
  if(userStage != 'Stage-6') {
    if(dandruffResp == 'Yes, heavy dandruff that sticks to the scalp') {
      let stageElement = document.querySelector('.male_pcos_causing_main');
      if(stageElement){
        document.querySelector('.male_pcos_causing_main').style.display = 'block';
      }
    }
  }

  if(userStage === 'Stage-1') {
    if(dandruffResp == 'Yes, heavy dandruff that sticks to the scalp') {
      // document.querySelector('.stageDescription_text').textContent = 'We will ensure your hair thickens and the hair line remains intact. We will begin your treatment by controlling dandruff this month.';
    }    
  }

  if(userStage === 'Stage-2' || userStage === 'Stage-3' || userStage === 'Stage-4' || userStage === 'Heavy Hair Fall Across The Head' || userStage === "Heavy Hair Fall") {
    if(dandruffResp == 'Yes, heavy dandruff that sticks to the scalp') {
      // document.querySelector('.stageDescription_text').textContent = `It will take ${data.Max_months} months to see visible results. We will begin your treatment by controlling dandruff this month.`;
    }
  }
  /* Dandruff Response */

  /* 3 Sections on All Stages Except Stage6 & Coin Size Patch Changes */
  var stage1Journey = document.querySelectorAll('.stage1-journey');
  var stage1Holistic = document.querySelectorAll('.holistic-safe');
    
  if(userStage == 'Stage-6') {
      let stage6plan = document.querySelector('.male-treatment-plan');
      let stage6plan2 = document.querySelector('.aldrich-faq');
      if(stage6plan && stage6plan2){
        document.querySelector('.male-treatment-plan').style.display = 'none';
        document.querySelector('.aldrich-faq').style.display = 'none';
      }
    }
  
  if(userStage != 'Stage-6') {
    let userStage6plan = document.querySelector('.stage1-doctors');
    if(userStage6plan){
      document.querySelector('.stage1-doctors').style.display = 'block';
    }
  }

  if(userStage == 'Stage-1' || userStage == 'Stage-6' || userStage == 'Coin Size Patch') {
    if(stage1Journey.length != 0) {
      stage1Journey.forEach((journey) => {
        journey.style.display = 'none';
      });
    }
  }else {
    if(stage1Journey.length != 0) {
      stage1Journey.forEach((journey) => {
        journey.style.display = 'block';
      });
    }
  }

  if(userStage == 'Stage-1' || userStage == 'Stage-6') {
    if(stage1Holistic.length != 0) {
      stage1Holistic.forEach((holistic) => {
        holistic.style.display = 'none';
      });
    }
  }else {
    if(stage1Holistic.length != 0) {
      stage1Holistic.forEach((holistic) => {
        holistic.style.display = 'block';
      });
    }
  }
  selectedStage = data.stage;
  document.querySelector(`.${selectedStage}`)?.classList.add('selectedStage');
  if (selectedStage === 'Stage-1') {
    // document.querySelector('.Stage-1')?.classList.add('all-stages');
    // document.querySelector('.main-stage-section')?.classList.add('all-stages-pd');
  } else if (selectedStage === 'Stage-2') {
    document.querySelector('.Stage-2-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-3') {
    document.querySelector('.Stage-3-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-4') {
    document.querySelector('.Stage-4-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-5') {
    document.querySelector('.Stage-5-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-6') {
    document.querySelector('.Stage-5')?.classList.add('checkStage');
  } else if (selectedStage === 'Coin Size Patch') {
    document.querySelector('.Stage-7')?.classList.add('selectedStage');
  } else if (selectedStage === 'Heavy Hair Fall Across The Head' || selectedStage === "Heavy Hair Fall") {
    document.querySelector('#male-stages')?.classList.add('male-stagesTE');
    document.querySelector('.TE_stage-name').style.display = "none";
    document.querySelector('#stageDescription')?.classList.add('stageDescriptionTE');
    document.querySelector('.Stage-8')?.classList.add('selectedStage');
    document.querySelector('.Stage-8-1')?.classList.add('checkStage', 'hide-text');
  }
  var __selectedStage = document.querySelectorAll(".selectedStage");
  if(__selectedStage.length) {
    __selectedStage.forEach((stage) => {
      var imageField = stage.querySelector("img");
      if(imageField && stageImage) imageField.setAttribute("src", stageImage);
    })
  }
  var diagnoses__image =  document.querySelector('.diagnoses-result > img');
  if(diagnoses__image) { diagnoses__image.style.display = 'none'; }
  if(ourdia) {
    var ourdia__li = ourdia.querySelectorAll('li');
    ourdia__li.forEach((li) => {
      li.style.display = 'none';
    });
    var ourdia__btns = ourdia.querySelectorAll('a');
    if(ourdia__btns.length != 0) {
      ourdia__btns.forEach((btns) => {
        btns.addEventListener('click', function(e) {
          e.preventDefault();
          var id = this.getAttribute('data-id'), tab_panes = document.querySelectorAll('.tab-pane'),
          nav__links = document.querySelectorAll('.nav-item.nav-link');
          tab_panes.forEach((pane) => {
            pane.classList.remove('active');
            pane.classList.remove('show');
          });
          document.querySelector(`#nav-tabContent #${id}`).classList.add('active');
          document.querySelector(`#nav-tabContent #${id}`).classList.add('show');
          nav__links.forEach((links) => {
            links.classList.remove('active');
          });
          document.querySelector(`#nav-tab #${id}-tab`).classList.add('active');
        });
      });
    }
  }
  var type = response.Recommendations.Type, Genetic = response.Recommendations.Genetic, User_Analysis = response.User_Analysis,
  Recommendations = response.Recommendations, hair_goals = response.hair_goals, stageTE = response.User_Analysis.stage,
  experienced_one_year = response.User_Analysis.experienced_in_one_year;
  // if (stageTE == "Stage-1"){
  //   var texts = response.hair_goals, newText = "";
  //   hair_goals[hair_goals.indexOf('Regrow hair')] = 'regrowth of hair wherever possible';
  //   hair_goals[hair_goals.indexOf('Control hair fall')] = 'reduction of hair fall';
  //   hair_goals[hair_goals.indexOf('I have a good set of hair, I want to maintain it.')] = 'maintenance of hair line';
  //   hair_goals[hair_goals.indexOf('Work on hair quality')] = 'better hair quality';
  //   hair_goals[hair_goals.indexOf('Delay greying')] = 'delay hair greying';
  //   for (var i = 0; i < texts.length; i++) {
  //     newText += hair_goals[i];
  //     if (i < texts.length - 2) {
  //        newText += ", ";
  //     } else if (i === texts.length - 2) {
  //       newText += " and ";
  //     }
  //   }
  //   document.querySelector(".male_result_commas").style.display = 'block';
  //   document.querySelector(".hair_golsmal").innerHTML = newText;
  // }
  if (stageTE == "Heavy Hair Fall Across The Head" || stageTE == "Heavy Hair Fall"){
    for(var i=0; i < experienced_one_year.length; i++){
      let experienced_one = experienced_one_year[i];
      if(experienced_one == "Severe Illness (Dengue, Malaria, Typhoid or Covid)"){
        var illness = document.querySelector('#illness');
        if(illness) illness.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
        var illnessTab = document.querySelector('#nav-illness-tab');
        if(illnessTab) illnessTab.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.
      }
      if (experienced_one == "Heavy weight loss / heavy weight gain"){
        var weight = document.querySelector('#weight-change');
        if(weight) weight.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
        var weighttab = document.querySelector('#nav-weight-change-tab');
        if(weighttab) weighttab.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
      }
      if (experienced_one == "Surgery / heavy medication"){
        var surgery = document.querySelector('#surgery');
        if(surgery) surgery.style.display = 'flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
        var surgerytab = document.querySelector('#nav-Surgery-tab')
        if(surgerytab) surgerytab.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
      }    
    } 
  }
  let count=0;
  if (stageTE == "Heavy Hair Fall Across The Head" || stageTE == "Heavy Hair Fall"){
    for(var i=0; i < experienced_one_year.length; i++){
    let experienced_one = experienced_one_year[i];
      if(experienced_one == "Severe Illness (Dengue, Malaria, Typhoid or Covid)" && count<4){
        var illness = document.querySelector('#illness');
        if(illness) illness.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
        var illnessTab = document.querySelector('#nav-illness-tab');
        if(illnessTab) illnessTab.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
         count++;
      }
      if(experienced_one == "Heavy weight loss / heavy weight gain" && count<4){
        var weight = document.querySelector('#weight-change');
        if(weight) weight.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
        var weighttab = document.querySelector('#nav-weight-change-tab');
        if(weighttab) weighttab.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
        count++;
      }
      if(experienced_one == "Surgery / heavy medication" && count<4){
        var surgery = document.querySelector('#surgery');
        if(surgery) surgery.style.display = 'flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
        var surgerytab = document.querySelector('#nav-Surgery-tab')
        if(surgerytab) surgerytab.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
        count++;
      }      
    }
  }
  
  if(User_Analysis.stage == "Coin Size Patch"){
    if (type === 5) {
      if(ourdia) {
        var ourdia__li = ourdia.querySelectorAll('li');
        if(ourdia__li.length != 0) {
          ourdia__li.forEach((li) => {
            li.style.display = 'none';
          });
        }
      }
      var nav_items = document.querySelectorAll('.nav-item');
      if(nav_items.length != 0) {
        nav_items.forEach((item) => { item.style.display = 'none'; })
      }
      var malfunction = document.querySelector('#malfunction');
      if(malfunction) malfunction.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js
      var malfunctiontab = document.querySelector('#nav-malfunction-tab');
      if(malfunctiontab) malfunctiontab.style.display ='flex'; // Display Those Root Cause on Stage Modal Who Are Present In Result4 Page & Added id with Comma on result4.js  
    }
  }
  var regroMonth1 = document.querySelector('#regroMonth1'), regroMonth2 = document.querySelector('#regroMonth2'),
  regroMonth3 = document.querySelector('#regroMonth3');
  if (data.Max_months < 6) {
    if(regroMonth1) { regroMonth1.innerHTML = '1 MONTH'; }
    if(regroMonth2) { regroMonth2.innerHTML = '2-3 MONTHS'; }
    if(regroMonth3) { regroMonth3.innerHTML = '4-5 MONTHS'; }
  }
  if (data.Max_months === 6) {
    if(regroMonth1) { regroMonth1.innerHTML = '1 MONTH'; }
    if(regroMonth2) { regroMonth2.innerHTML = '2-4 MONTHS'; }
    if(regroMonth3) { regroMonth3.innerHTML = '5-6 MONTHS'; }
  }
  if (data.Max_months > 6) {
    if(regroMonth1) { regroMonth1.innerHTML = '1-2 MONTHS'; }
    if(regroMonth2) { regroMonth2.innerHTML = '3-5 MONTHS'; }
    if(regroMonth3) { regroMonth3.innerHTML = '5-8 MONTHS'; }
  }
  var atcButtonRP4 = document.querySelectorAll('#add-to-cart-result-page'),
  stickyAtcButtonRP4 =  document.querySelectorAll('.sticky-btn #add-to-cart-result-page');
  if(atcButtonRP4.length != 0) {
    atcButtonRP4.forEach((btn) => {
      btn.setAttribute('user-mobile', data.phone);
      btn.setAttribute('user-email', data.email);
    });
  }
  if(stickyAtcButtonRP4.length != 0) {
    stickyAtcButtonRP4.forEach((btn) => {
      btn.setAttribute('user-mobile', data.phone);
      btn.setAttribute('user-email', data.email);
    });
  }
  if(window.location.pathname == '/pages/result4') {
    window.addEventListener('scroll', function() {
      var productSectionList = document.querySelector('.product-section-list');
      var stickyBtn = document.querySelector('.sticky-btn');
      var result4StickyTotal = document.querySelector('.sticky-btn .result4_sticky_total');
      var windowHeight = window.innerHeight;
      var scrollTop = window.scrollY;
      if (scrollTop >= productSectionList.offsetTop + productSectionList.offsetHeight - windowHeight) {
        stickyBtn.style.display = 'block';
        result4StickyTotal.style.display = 'flex';
      } else {
        stickyBtn.style.display = 'none';
        result4StickyTotal.style.display = 'none';
      }
      var siteFooter = document.querySelector('.result4 .site-footer');
      if(siteFooter) {
        if (scrollTop >= siteFooter.offsetTop - windowHeight) {
          stickyBtn.style.position = 'fixed';
        } else {
          stickyBtn.style.position = 'fixed';
        }
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const listItems = document.querySelectorAll(".f-b-main-li");
  const anchorLinks = document.querySelectorAll(".nav-link");
  const tabLinks = document.querySelectorAll(".tab-pane");

  listItems.forEach(function (item) {
    item.addEventListener("click", function () {
      const target = this.getAttribute("data-targets");
      triggerAction(target);
    });
  });

  function triggerAction(target) {
    anchorLinks.forEach(function (link) {
      if (link.getAttribute("data-targets") === target) {
        anchorLinks.forEach(function (link) {
          link.classList.remove("active");
        });
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });

    tabLinks.forEach(function (tab) {
      if (tab.getAttribute("data-targets") === target) {
        tabLinks.forEach(function (tab) {
          tab.classList.remove("active");
          tab.classList.remove("show");
        });
        tab.classList.add("active");
        tab.classList.add("show");
      } else {
        tab.classList.remove("active");
        tab.classList.remove("show");
      }
    });
  }
});

function cartData() {
  window.dataLayer = window.dataLayer || [];
  function gtag(){
    dataLayer.push(arguments);
  }
  fetch("/cart.js").then((cart) => {
    return cart.json();
  }).then((cart) => {
    var items = [];
    cart.items.forEach((item) => {
      items.push({
        "item_id": item.id,
        "item_name": item.title,
        "item_brand": "Traya Health",
        "item_category": "",
        "price": (parseInt(item.price) / 100),
        "quantity": item.quantity
      })
    });
    var eventData = {
      "currency": cart.currency,
      "value": (parseInt(cart.items_subtotal_price) / 100),
      "items": items
    };
    gtag("event", "view_cart", eventData);
  }).catch((error) => {
    console.error("Error: ", error);
  })
}

function showOrHide(partition, state) {
  partition.forEach((part) => {
    part.style.display = `${state}`;
  })
}